import React, { useContext } from 'react';
import { CartContext } from '../../Context/CartContext';
import NumberFormat from 'react-number-format';

function OrderSummary(props) {
  const [cart, setCart] = useContext(CartContext);

  function totalPrice() {
    let t = cart.cabins.reduce((a, b) => +a + b.price, 0);
    return parseInt(t);
  }
  function renderPrice(price) {
    return <NumberFormat
      value={price}
      decimalScale={0}
      displayType={'text'}
      decimalSeparator={','}
      thousandSeparator={'.'}
      prefix={'DKK '}
    />
  }

  return (
    <React.Fragment>
      <h5 className="px-4"><span className={props.headerClass}>Order summary</span></h5>
      <div className="border p-4 bg-white">
        <div className="hidden">
          <div>MasterId: {cart.masterId}</div>
          <div>PackageId: {cart.packageId}</div>
        </div>
        <div className="text-lg">{cart.name}</div>
        <div className="text-lg pb-2">Departure: {
          new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "long"
          }).format(new Date(cart.departure))
        }
        </div>
        {cart.cabins.length > 1
          ? <div>{cart.cabins.length} cabins: </div>
          : null
        }
        {cart.cabins.map((cabin, index) =>
          <div key={"cabin_" + index} className="pb-4">
            <p className="font-semibold">Cabin {index + 1}</p>
            <div >
              <div className="hidden">CabintypeId: {cabin.cabintypeId}</div>
              {cabin.adults ? <div>Adults: {cabin.adults}</div> : null}
              {cabin.seniors ? <div>Seniors: {cabin.seniors}</div> : null}
              {cabin.children ? <div>Children: {cabin.children}</div> : null}
              {cabin.juniorChildren ? <div>Junior-children: {cabin.juniorChildren}</div> : null}
              {cabin.infants ? <div>Infants: {cabin.infants}</div> : null}
              <div>Cabintype: {cabin.cabintypeName || "missing"}</div>
              <div>
                <NumberFormat
                  value={parseInt(cabin.price)}
                  displayType={'text'} decimalSeparator={','} thousandSeparator={'.'}
                  prefix={'Price: '} />
              </div>
            </div>
          </div>
        )}
        <div className="flex justify-between font-bold text-lg">
          <div>Total to pay</div>
          <div>{renderPrice(totalPrice())}</div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default OrderSummary;